import { create } from "zustand";

const useSignInStore = create((set) => ({
    loginId: "",
    password: "",
    isLoading: false,
    error: null,
    isLoggedIn: false,
    setId: (id) => set({ loginId: id }),
    setPassword: (password) => set({ password }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    setLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
    resetForm: () => set({ loginId: "", password: "", error: null }),
    checkAutoLogin: async () => {
        const token = localStorage.getItem("authToken");
        const userId = localStorage.getItem("userId");
        if (token && userId) {
            try {
                //토큰 유효성 확인 API 호출
                // const response = await validateToken(token);
                // if (response.isValid) {
                //     set({ isLoggedIn: true });
                // } else {
                //     localStorage.removeItem('authToken');
                //     localStorage.removeItem('userId');
                // }
                set({ isLoggedIn: true }); // 임시로 항상 유효하다고 가정
            } catch (error) {
                console.error("자동 로그인 확인 실패:", error);
                localStorage.removeItem("authToken");
                localStorage.removeItem("userId");
            }
        }
    },
    logout: () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        set({ isLoggedIn: false });
    },
}));

export default useSignInStore;
